import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";
import moment, { invalid } from "moment";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import "./_permissionDetails.scss"


const ADD_PERMISSION_DETAILS = gql`
  mutation($params: AddPermissionDetails) {
    addPermissionDetails(params: $params)
  }`


class PermissionDetailsModal extends Component {
    constructor() {
        super()
        this.state = {
            comments: "",
            submitError: "",
            submitted: false,
            loader: 0,
            dataClear: 1
        }
    }

    handleChange = (e) => {
        this.setState({
            comments: e.target.value
        })
    }

    handleSubmit = (value) => {
        const params = {
            permission_id: this.props.stateData.individualPermissionData.permission_id,
            permission_status: parseInt(value),
            permission_type_id: 1,
            approved_by: 1,
            comments: this.state.comments
        }


        this.setState({
            loader: 1
        });

        this.addPermissionDetails(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log("params", params);
            console.log(error);


            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loader: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
        setTimeout(() => {
            this.props.onHide();
        }, 2000);
    }


    addPermissionDetails = async (
        params) => {
        await this.props.addPermissionDetails({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addPermissionDetails) {
                    this.setState({
                        loader: 0,
                        submitted: true
                    })
                    setTimeout(() => {
                        window.location.reload(true)
                    }, 2000)
                }
            }

        });
    };



    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                comments: "",
                submitError: "",
                submitted: false,
                loader: 0,
                dataClear: 1
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    render() {
        console.log("pe", this.props.stateData.individualPermissionData);
        const fromDate = moment.unix(this.props.stateData.individualPermissionData.from_datetime).format('DD-MM-YYYY HH:mm:ss')
        const toDate = moment.unix(this.props.stateData.individualPermissionData.to_datetime).format('DD-MM-YYYY HH:mm:ss')
        const outTime = moment.unix(this.props.stateData.individualPermissionData.outtime).format("DD-MM-YYYY HH:mm:ss")
        const inTime = moment.unix(this.props.stateData.individualPermissionData.intime).format("DD-MM-YYYY HH:mm:ss")
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Permission Details</Modal.Title>
                </Modal.Header>
                {
                    this.props.stateData.blockType == "1" || this.props.stateData.individualPermissionData.permission_status == null ? (
                        <>
                            <Modal.Body className="p-4">
                                <Container fluid>
                                    <Row className="">
                                        <Col sm={12}>
                                            <h4>{this.props.stateData.individualPermissionData.request_message}</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}>
                                            <img src={this.props.stateData.individualPermissionData.receiver_image_path} alt="" width={90} height={85} />
                                            <p className="mt-3"> Receiver Name: <span className="font-weight-bold f-18">{this.props.stateData.individualPermissionData.receiver_name}</span></p>
                                            <p className="mt-3"> Receiver Mobile: <span className="font-weight-bold f-18">{this.props.stateData.individualPermissionData.receiver_mobile}</span></p>
                                        </Col>
                                        <Col sm={6}>
                                            <h6>Requested Timings</h6>
                                            <Row className="mt-3">
                                                <Col sm={6}>
                                                    <h6>From Date: </h6>
                                                    <div className="div_box rounded mr-3" >{fromDate}</div>
                                                </Col>
                                                <Col sm={6}>
                                                    <h6 className="">To Date:</h6>
                                                    <div className="div_box rounded mr-3" >{toDate}</div>
                                                </Col>
                                            </Row>
                                            <Row className="mt-2">
                                                <Col sm={12}>
                                                    <h6> Comments:</h6>
                                                    <span><textarea onChange={this.handleChange} disabled={this.props.stateData.individualPermissionData.permission_request_type_id != 2 ? false : true} style={{ width: "300px", height: "50px" }}></textarea></span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    {
                                        this.props.stateData.individualPermissionData.permission_request_type_id != 2 ? (
                                            <Row>
                                                <Col sm={12} className="text-center mt-3">
                                                    <Button className=" btn btn-success m-3" onClick={(e) => this.handleSubmit(1)}>
                                                        Accept Request</Button>
                                                    <Button className=" btn btn-danger" onClick={(e) => this.handleSubmit(2)}>
                                                        Decline Request </Button>
                                                </Col>
                                            </Row>
                                        ) : ("")
                                    }
                                    <Row>
                                        <Col>
                                            {
                                                this.state.submitError != "" ? (
                                                    <p className="text-success mt-1 text-center" >{this.state.submitError}</p>
                                                ) : ""
                                            }
                                            {
                                                this.state.submitted == true ? (
                                                    <p className="text-success mt-1 text-center" >Status Submitted </p>
                                                ) : ""
                                            }
                                            {
                                                this.state.loader == 1 ? (
                                                    <span className="spinner-border spinner-border-sm text-center spinner-alignment"></span>
                                                ) : ""
                                            }
                                        </Col>
                                    </Row>
                                </Container>
                            </Modal.Body>

                        </>
                    ) : this.props.stateData.blockType == "2" || this.props.stateData.individualPermissionData.permission_status == "1" ? (
                        <Modal.Body className="p-4">
                            <Container fluid>
                                <Row className="">
                                    <Col sm={9}>
                                        <h4>{this.props.stateData.individualPermissionData.request_message}</h4>
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col sm={6}>
                                        <img src={this.props.stateData.individualPermissionData.receiver_image_path} alt="" width={90} height={85} />
                                        <p className="mt-3"> Receiver Name: <span className="font-weight-bold f-18">{this.props.stateData.individualPermissionData.receiver_name}</span></p>
                                        <p className="mt-3"> Receiver Mobile: <span className="font-weight-bold f-18">{this.props.stateData.individualPermissionData.receiver_mobile}</span></p>

                                        <h6 className="mt-2"> Comments:</h6>
                                        <span><textarea value={this.props.stateData.individualPermissionData.comments} disabled={true} style={{ width: "300px", height: "50px" }}></textarea></span>
                                    </Col>
                                    <Col sm={6}>
                                        <h6>Requested Timings:</h6>
                                        <Row className="mt-3">
                                            <Col sm={6}>
                                                <h6>From Date:</h6>
                                                <div className="div_box rounded mr-3" >{fromDate}</div>
                                            </Col>
                                            <Col sm={6}>
                                                <h6 className="">To Date:</h6>
                                                <div className="div_box rounded mr-3" >{toDate}</div>
                                            </Col>
                                        </Row>
                                        {
                                            this.props.stateData.individualPermissionData.outtime != null ?
                                                <Row className="mt-3">
                                                    <Col sm={6}>
                                                        <h6>Leaving Timings</h6>
                                                        <div className="div_box rounded mr-3">{outTime}</div>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <img src={this.props.stateData.individualPermissionData.outtime_image_path} alt="" width={90} height={85} />
                                                    </Col>
                                                </Row> : ""
                                        }
                                        {
                                            this.props.stateData.individualPermissionData.intime != null ?
                                                <Row className="mt-3">
                                                    <Col sm={6}>
                                                        <h6>In Timings</h6>
                                                        <div className="div_box rounded mr-3" >{inTime}</div>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <img src={this.props.stateData.individualPermissionData.intime_image_path} alt="" width={90} height={85} />
                                                    </Col>
                                                </Row> : ""
                                        }
                                    </Col>
                                </Row>
                            </Container>
                        </Modal.Body>
                    ) : this.props.stateData.blockType == "3" || this.props.stateData.individualPermissionData.permission_status == "2" ? (
                        <Modal.Body className="p-4">
                            <Container fluid>
                                <Row className="">
                                    <Col sm={9}>
                                        <h4>{this.props.stateData.individualPermissionData.request_message}</h4>
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col sm={6}>
                                        <img src={this.props.stateData.individualPermissionData.receiver_image_path} alt="" width={90} height={85} />
                                        <p className="mt-3"> Receiver Name: <span className="font-weight-bold f-18">{this.props.stateData.individualPermissionData.receiver_name}</span></p>
                                        <p className="mt-3"> Receiver Mobile: <span className="font-weight-bold f-18">{this.props.stateData.individualPermissionData.receiver_mobile}</span></p>
                                        <h6 className="mt-2"> Rejected Comments:</h6>
                                        <span><textarea value={this.props.stateData.individualPermissionData.comments} disabled={true} style={{ width: "300px", height: "50px" }}></textarea></span>
                                    </Col>
                                    <Col sm={6}>
                                        <h6>Requested Timings:</h6>
                                        <Row className="mt-3">
                                            <Col sm={6}>
                                                <h6>From Date:</h6>
                                                <div className="div_box rounded mr-3" >{fromDate}</div>
                                            </Col>
                                            <Col sm={6}>
                                                <h6 className="">To Date:</h6>
                                                <div className="div_box rounded mr-3" >{toDate}</div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Container>
                        </Modal.Body>
                    ) : ""
                }

            </Modal>

        )
    }
}
export default withRouter(compose(
    graphql(ADD_PERMISSION_DETAILS, {
        name: "addPermissionDetails"
    })

)(PermissionDetailsModal));

